<template>
    <div>
        <div><i class="material-icons">sentiment_very_dissatisfied</i></div>
        <p>Her har det gått noe galt tipper vi!</p>
        <h3>Hva har skjedd?</h3>
        <div class="actions">
            <div>
                <button @click.prevent="send('reconsider')">Jobben er priset feil</button>
            </div>
            <div>
                <button @click.prevent="send('reject')">Jobben skal kanselleres</button>
            </div>
        </div>
    </div>
</template>

<script>

    import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components

    export default {
        data () {
            return {}
        },
        mixins: [VuejsDialogMixin],
        methods: {
            send(res){
                this.proceed(res);
            }
        }
    }
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// RejectTeslaOffer.vue?7930637a